"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get OAuthModule () {
        return OAuthModule;
    },
    get oAuthModuleMetadata () {
        return oAuthModuleMetadata;
    }
});
const _common = require("@nestjs/common");
const _nocomodule = require("~/modules/noco.module");
const _oauthclientservice = require("~/modules/oauth/services/oauth-client.service");
const _oauthcontroller = require("~/modules/oauth/controllers/oauth.controller");
const _oauthauthorizationservice = require("~/modules/oauth/services/oauth-authorization.service");
const _oauthtokenservice = require("~/modules/oauth/services/oauth-token.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const oAuthModuleMetadata = {
    imports: [
        (0, _common.forwardRef)(()=>_nocomodule.NocoModule)
    ],
    controllers: [
        ...process.env.NC_WORKER_CONTAINER !== 'true' ? [
            _oauthcontroller.OAuthController
        ] : []
    ],
    providers: [
        _oauthclientservice.OauthClientService,
        _oauthauthorizationservice.OauthAuthorizationService,
        _oauthtokenservice.OauthTokenService
    ],
    exports: [
        _oauthclientservice.OauthClientService,
        _oauthtokenservice.OauthTokenService
    ]
};
let OAuthModule = class OAuthModule {
};
OAuthModule = _ts_decorate([
    (0, _common.Module)(oAuthModuleMetadata)
], OAuthModule);
